require("plyr");
require("../vendors/plyr-master/dist/plyr.css"); //css modifiée donc pas npm
var mySvg=require("../vendors/plyr-master/dist/plyr.svg");
//=the()->fileSystem->fileGetContents("fk.app/pub/vendors/plyr-master/dist/plyr.svg"
import plyr from "plyr"
/**
 * Gestionnaire de plyr.js
 */
export default class VideoPlyr{

    constructor(plyrInstance){
        let me=this;
        this.id=""+new Date().getTime()+"_"+Math.random()*10000;

        this.$main=$(plyrInstance.getContainer());
        this.$mainOriginal=this.$main.find(".js-plyr");
        VideoPlyr.all.push(this);
        /**
         * @type {plyr}
         */
        this.plyr=plyrInstance;
        this.plyr.on("seeking",function(){
           me.stopOthers();
        });
        this.plyr.on('play', function(event) {
            VideoPlyr.setCurrent(this);
            me.stopOthers();
        });
        if(this.$mainOriginal.attr("autoplay")){
            this.plyr.on("ready",function(){
                me.play();
            })

        }
    }

    stopOthers(){
        let me=this;
        $.each(VideoPlyr.all,function(k,v){
            if(v.$main.is("body div")){
                if(v.id !== me.id){
                    v.pause();
                }
            }else{
                //si le player est plus dans le dom
                v.plyr.destroy();
            }

        })
    }
    play(){
        this.plyr.play();
    }
    pause(){
        this.plyr.pause();
    }

    /**
     *
     * @param {VideoPlyr} vdo
     */
    static setCurrent(vdo){
        VideoPlyr.currentOne=vdo;

    }

    /**
     * Initialise tous les js-plyr qui ne l'ont pas été
     */
    static initFromDom(){

        //let svgUrl=LayoutVars.fmkHttpRoot+"/"+"fk.app/pub/vendors/plyr-master/dist/plyr.svg";
        //console.log("svgUrl",svgUrl)
        // Setup the player

        //hello
        let options={
            debug: false,
            title: "Vidéo",
            volume:10,
            //iconUrl: svgUrl, directement dans le layout
            loadSprite:false,
            controls:[
                'play-large',
                'play',
                'progress',
                //'current-time',
                //'mute',
                //'volume',
                //'captions',
                //'fullscreen'
            ],
            tooltips: {
                controls: true
            },
            captions: {
                defaultActive: true
            },
            storage:{
                enable:false,
                key:"plyr_volume"
            }
        };
        let newOnes=plyr.setup(
            document.querySelectorAll('.js-plyr'),options
        );
        //console.log("initFromDom",newOnes);
        $.each(newOnes,function(k,v){
            new VideoPlyr(v);
        })
    }
}




/**
 *
 * @type {VideoPlyr[]}
 */
VideoPlyr.all=[];
/**
 *
 * @type {VideoPlyr}
 */
VideoPlyr.currentOne=null;


// WEBPACK FOOTER //
// ./fk.app/_src/plugins-relay/VideoPlyr.js